import { translateFn } from '../../../../../../utils/translator.helper';
import { htmlEncode } from '../../../../../../utils/escape.utils';
import { RepeatInterval, WeekDays } from '@nirvana/shared/dtos/types/policies/common';
import { SelectOption } from '../../../../../../ui/gzDropdown/types';

export function getRepeatIntervalFormOptions(): {
  [repeatInterval in RepeatInterval]: { title: string; value: RepeatInterval };
} {
  return {
    [RepeatInterval.HOURS]: {
      title: translateFn('hours'),
      value: RepeatInterval.HOURS,
    },
    [RepeatInterval.DAYS]: {
      title: translateFn('days'),
      value: RepeatInterval.DAYS,
    },
    [RepeatInterval.WEEKDAYS]: {
      title: translateFn('weeks'),
      value: RepeatInterval.WEEKDAYS,
    },
  };
}

export function getRepeatIntervalFormOptionsForSelection(): SelectOption[] {
  return [
    {
      title: translateFn('Hourly'),
      value: RepeatInterval.HOURS,
    },
    {
      title: translateFn('Daily'),
      value: RepeatInterval.DAYS,
    },
    {
      title: translateFn('Weekly'),
      value: RepeatInterval.WEEKDAYS,
    },
  ];
}

export const WeekDayValueToScheduleFieldName = {
  [WeekDays.Monday]: 'recurrentDayMon',
  [WeekDays.Tuesday]: 'recurrentDayTue',
  [WeekDays.Wednesday]: 'recurrentDayWed',
  [WeekDays.Thursday]: 'recurrentDayThu',
  [WeekDays.Friday]: 'recurrentDayFri',
  [WeekDays.Saturday]: 'recurrentDaySat',
  [WeekDays.Sunday]: 'recurrentDaySun',
};

export const WeekDayValueToScheduleFieldNameExchange = {
  [WeekDays.Monday]: 'runEveryMonday',
  [WeekDays.Tuesday]: 'runEveryTuesday',
  [WeekDays.Wednesday]: 'runEveryWednesday',
  [WeekDays.Thursday]: 'runEveryThursday',
  [WeekDays.Friday]: 'runEveryFriday',
  [WeekDays.Saturday]: 'runEverySaturday',
  [WeekDays.Sunday]: 'runEverySunday',
};

export const WeekDaysKeys = Object.values(WeekDays).filter(x => isNaN(Number(x))); // Monday, Tuesday etc.
export const WeekDaysValues = Object.values(WeekDays).filter(x => !isNaN(Number(x))); // 1, 2 etc.

export function getWeekDaysFormOptions() {
  // we should use getSchedulerStrings method from BaseWebComponentTranslator when add/edit policy will be full web components
  const shortNames = {
    Sunday: htmlEncode(translateFn('Sun')),
    Monday: htmlEncode(translateFn('Mon')),
    Tuesday: htmlEncode(translateFn('Tue')),
    Wednesday: htmlEncode(translateFn('Wed')),
    Thursday: htmlEncode(translateFn('Thu')),
    Friday: htmlEncode(translateFn('Fri')),
    Saturday: htmlEncode(translateFn('Sat')),
  };

  return Array.from(WeekDaysKeys, (element: string) => ({
    label: shortNames[element],
    value: parseInt(WeekDays[element], 10),
  }));
}
